<HeaderOpen></HeaderOpen><article class="article wrapper__page"><slot></slot></article>